/*
 * @Author: shannyHuang
 * @Date: 2022-07-07 22:09:35
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-12-09 10:23:54
 * @FilePath: /wemeet-web-activity/src/components/HomeHeader/FollowGuide/mobile.tsx
 */
/** 关注完成后的 gif 提示; mobile样式 */
import React from 'react';
import useFollowGuide, { IProps } from './logic';
import PlusIcon from '@tencent/tpm-meeting-active/lib/Icon/icons/PlusIcon';
import CheckIcon from '@tencent/tpm-meeting-active/lib/Icon/icons/CheckIcon';
import Button from '@tencent/tpm-meeting-active/lib/Button';
import GuideMobile from './guideMobile';

const FollowGuideMobile: React.FC<IProps> = ({ isSubscribed, hostId, toggleSubscribe }) => {
  const { bubbleVisible, onSubscribe, handleKnowBtn, handleNoRemind, justHide } = useFollowGuide({
    hostId,
    toggleSubscribe,
  });

  return (
    <>
      <GuideMobile
        visible={bubbleVisible}
        onClose={justHide}
        handleKnowBtn={handleKnowBtn}
        handleNoRemind={handleNoRemind}
      />
      {isSubscribed ? (
        <Button className="ma-home-hero__btn attention-btn special-width" onClick={onSubscribe}>
          <CheckIcon />
          已关注
        </Button>
      ) : (
        <Button
          onClick={onSubscribe}
          className="ma-home-hero__btn attention-btn special-width"
          type="primary"
        >
          <PlusIcon />
          关注
        </Button>
      )}
    </>
  );
};

export default FollowGuideMobile;
